import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress all React error overlays and popups
// Disable React DevTools error overlay
if (typeof window !== 'undefined') {
  // Function to remove any error overlay elements from DOM
  const removeErrorOverlays = () => {
    // Remove webpack-dev-server overlay
    const webpackOverlay = document.getElementById('webpack-dev-server-client-overlay');
    if (webpackOverlay) {
      webpackOverlay.remove();
    }
    // Remove React error overlay
    const reactOverlay = document.querySelector('[data-react-error-overlay]') || 
                         document.querySelector('#react-error-overlay') ||
                         document.querySelector('.react-error-overlay');
    if (reactOverlay) {
      reactOverlay.remove();
    }
    // Remove any iframe overlays
    const overlayIframes = document.querySelectorAll('iframe[src*="webpack"], iframe[src*="overlay"]');
    overlayIframes.forEach(iframe => iframe.remove());
  };

  // Remove overlays immediately and on interval
  removeErrorOverlays();
  setInterval(removeErrorOverlays, 1000);

  // Suppress ResizeObserver warnings (harmless browser quirk)
  const originalError = console.error;
  const originalWarn = console.warn;
  
  console.error = (...args) => {
    const errorMessage = args[0]?.toString() || '';
    // Suppress ResizeObserver errors
    if (errorMessage.includes('ResizeObserver loop') || 
        errorMessage.includes('ResizeObserver loop completed with undelivered notifications')) {
      return;
    }
    // Still log to console but don't show overlay
    originalError.apply(console, args);
    // Remove any overlays that might have appeared
    setTimeout(removeErrorOverlays, 0);
  };
  
  console.warn = (...args) => {
    const warnMessage = args[0]?.toString() || '';
    // Suppress ResizeObserver warnings
    if (warnMessage.includes('ResizeObserver')) {
      return;
    }
    originalWarn.apply(console, args);
  };

  // Disable React error overlay
  window.addEventListener('error', (event) => {
    console.error('Error caught:', event.error, event.message, event.filename, event.lineno);
    // Remove any overlays
    setTimeout(removeErrorOverlays, 0);
    // Prevent default to stop error overlay
    event.preventDefault();
    return false;
  }, true);

  window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason);
    // Remove any overlays
    setTimeout(removeErrorOverlays, 0);
    // Prevent default to stop error overlay
    event.preventDefault();
    return false;
  });

  // Disable React DevTools overlay if it exists
  if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
    const hook = window.__REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (hook.onCommitFiberRoot) {
      const originalOnCommitFiberRoot = hook.onCommitFiberRoot;
      hook.onCommitFiberRoot = function(...args) {
        try {
          return originalOnCommitFiberRoot.apply(this, args);
        } catch (e) {
          console.error('React DevTools error (suppressed):', e);
        }
      };
    }
  }

  // Suppress React error overlay by overriding the error handler
  window.onerror = function(message, source, lineno, colno, error) {
    console.error('Window error (suppressed overlay):', message, source, lineno, colno, error);
    // Remove any overlays
    setTimeout(removeErrorOverlays, 0);
    // Return true to prevent default error handling (which shows overlay)
    return true;
  };

  // Suppress unhandled promise rejections
  window.onunhandledrejection = function(event) {
    console.error('Unhandled rejection (suppressed overlay):', event.reason);
    // Remove any overlays
    setTimeout(removeErrorOverlays, 0);
    event.preventDefault();
    return true;
  };

  // Monitor DOM for overlay insertion and remove immediately
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          const element = node;
          if (element.id === 'webpack-dev-server-client-overlay' ||
              element.getAttribute('data-react-error-overlay') ||
              element.classList?.contains('react-error-overlay') ||
              (element.tagName === 'IFRAME' && element.src?.includes('overlay'))) {
            element.remove();
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

